import { Derivation } from '../interfaces/Derivation';
import { useEffect, useRef, useState, useMemo } from 'react';
import { DerivationStatus } from '../enums/DerivationStatus';

const STORAGE_KEY = 'openedDerivations';

const useNewDerivations = (derivations: Derivation[] | [], isLoading: boolean) => {
  const prevDerivationsRef = useRef(new Set<string>());
  const [newDerivations, setNewDerivations] = useState<Set<string>>(new Set());

  const pendingDerivations = useMemo(
    () => derivations.filter((d) => d.status === DerivationStatus.PENDING),
    [derivations]
  );
  const pendingIds = useMemo(() => pendingDerivations.map((d) => d.id), [pendingDerivations]);

  useEffect(() => {
    const openedFromStorage = new Set<string>(
      JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')
    );
    prevDerivationsRef.current = openedFromStorage;
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const openedFromStorage = prevDerivationsRef.current;
      const newIds = new Set(
        pendingIds.filter((id) => !openedFromStorage.has(id))
      );

      setNewDerivations(newIds);
    }
  }, [pendingIds.join(','), isLoading]);

  const removeNewTag = (id: string) => {
    setNewDerivations((prev) => {
      const updated = new Set(prev);
      updated.delete(id);

      const openedDerivations = new Set([...prevDerivationsRef.current, id]);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(openedDerivations)));
      prevDerivationsRef.current = openedDerivations;

      return updated;
    });
  };

  return { newDerivations, removeNewTag };
};

export default useNewDerivations;
